<div class="table-component flex flex-grow flex-column">
    <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="mb-xxs"
        fxLayoutGap="2%"
    >
        <div
            class="search-wrapper"
            fxLayout="row"
            fxLayoutAlign="center center"
        >
            <input
                #filter
                placeholder="Wpisz szukaną frazę"
                class="search-bar"
                [formControl]="filterControl"
                (keyup.enter)="filterByTrigger()"
            />
            <mat-icon class="text-primary" (click)="clearFilter()"
                >close</mat-icon
            >
            <mat-icon class="text-primary" (click)="filterByTrigger()"
                >search</mat-icon
            >
        </div>
        <div *ngIf="isEditMode">
            <div
                (click)="openImportDialog()"
                style="cursor: pointer;"
                fxLayout="column"
                fxLayoutAlign="center center"
            >
                <mat-icon class="text-primary">cloud_upload</mat-icon>
                <span class="toolbar-icon-text" style="text-align: center;"
                    >Importuj plik</span
                >
            </div>
        </div>
        <button-spinner class="ml-xxs" [inProgress]="importLoading">
            <div
                (click)="export('xlsx')"
                style="cursor: pointer;"
                fxLayout="column"
                fxLayoutAlign="center center"
            >
                <mat-icon class="toolbar-icon text-primary"
                    >cloud_download</mat-icon
                >
                <span class="toolbar-icon-text" style="text-align: center;"
                    >Eksportuj XLSX</span
                >
            </div>
        </button-spinner>
        <button-spinner class="ml-xxs" [inProgress]="importLoading">
            <div
                (click)="export('csv')"
                style="cursor: pointer;"
                fxLayout="column"
                fxLayoutAlign="center center"
            >
                <mat-icon class="toolbar-icon text-primary"
                    >cloud_download</mat-icon
                >
                <span class="toolbar-icon-text" style="text-align: center;"
                    >Eksportuj CSV</span
                >
            </div>
        </button-spinner>
    </div>

    <div class="table-wrapper flex flex-column flex-grow">
        <inner-loader [isActive]="isLoadingResults"></inner-loader>
        <mat-table
            #table
            id="table"
            [dataSource]="data"
            class="mat-cell flex flex-grow flex-column"
            [class.competitor-table]="isComp"
        >
            <ng-container
                *ngFor="let column of columnsData"
                [matColumnDef]="column.columnDef"
            >
                <mat-header-cell *matHeaderCellDef [fxFlex]="column.width">
                    <pr-drop-select
                        [placeholder]="column.header"
                        class="cell-header-wrapper"
                        fxLayout="row"
                        fxLayoutAlign="space-between center"
                        fxFlexFill
                        [optLabel]="column.header"
                        [selectName]="selectSortName(column)"
                        (change)="sortChange($event)"
                        [filterDef]="column.filterValue"
                        (filterChanged)="selFilterChanged($event)"
                        [isSelected]="checkIfSelected(column.columnDef)"
                    >
                    </pr-drop-select>
                </mat-header-cell>
                <mat-cell
                    *matCellDef="let row"
                    [fxFlex]="column.width"
                    [matTooltip]="getTooltip(column, row[column.columnDef])"
                    [matTooltipDisabled]="!column.tooltipEnabled"
                >
                    <div *ngIf="column.type && column.type === 'date'">
                        {{
                            generalService.parseDate(row[column.columnDef]) ||
                                '-'
                        }}
                    </div>
                    <div *ngIf="column.type && column.type === 'datetime'">
                        {{
                            generalService.parseDateWithTime(
                                row[column.columnDef]
                            ) || '-'
                        }}
                    </div>
                    <div
                        *ngIf="column.type && column.type === 'vat'"
                        class="percentage-suf"
                    >
                        {{
                            generalService.parseVAT(row[column.columnDef])
                                | number: '.0-0'
                        }}
                    </div>
                    <div *ngIf="column.type && column.type === 'number'">
                        {{ row[column.columnDef] || '-' }}
                    </div>
                    <div *ngIf="!column.suffix && !column.type">
                        {{ row[column.columnDef] || '-' }}
                    </div>
                    <div
                        *ngIf="column.type && column.type === 'margin'"
                        class="percentage-suf"
                    >
                        {{
                            generalService.parseVAT(row[column.columnDef])
                                | number: '.1-1'
                        }}
                    </div>
                    <div
                        *ngIf="
                            !column.type &&
                            column.suffix &&
                            column.suffix === 'percentage'
                        "
                        class="percentage-suf"
                    >
                        {{ row[column.columnDef] || '-' }}
                    </div>
                    <div
                        *ngIf="column.suffix && column.suffix === 'currency'"
                        class="currency-suf"
                    >
                        {{ (row[column.columnDef] | number: '.2-2') || '-' }}
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>

            <mat-row
                *matRowDef="let row; columns: displayedColumns"
                (click)="notImplemented(row)"
            >
            </mat-row>
        </mat-table>

        <mat-toolbar>
            <mat-toolbar-row>
                <!-- here select button -->
                <mat-paginator
                    [pageSize]="pageSize"
                    [pageSizeOptions]="[10, 25, 50, 100]"
                    [length]="itemsLength"
                    (page)="pageEvent = getPaginatorData($event)"
                ></mat-paginator>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
</div>
